module.exports = __webpack_public_path__ + "static/media/viveka-world.54490e84.png";